import { createClient as createChatbotsFetchClient } from "@zapier/api-clients/apis/chatbotsapi";
import { createClient as createInterfacesFetchClient } from "@zapier/api-clients/apis/interfaces";
import { type components } from "@zapier/api-clients/apis/interfaces/types";
import { createClient as createMonolithFetchClient } from "@zapier/api-clients/apis/monolith";
import { createClient as createTablesFetchClient } from "@zapier/api-clients/apis/tables";
import { createClient as createZslApiFetchClient } from "@zapier/api-clients/apis/zslapi";
import createClient from "openapi-react-query";
import { fetchWithProjectSession } from "./project-sessions/fetch";

export type InterfacesAPI = components["schemas"];
export type InterfacesPage = InterfacesAPI["InterfacesPage"];

export type InterfacesPageWithContent =
  InterfacesAPI["InterfacesPageWithContent"];

export type CheckCustomDomainResponse =
  InterfacesAPI["CheckCustomDomainResponse"];

export type Consumer = InterfacesAPI["Consumer"];

export type CreateZapInput = InterfacesAPI["CreateZapInput"];
export type Zap = InterfacesAPI["Zap"];

export type UpdateInterfaceInput = InterfacesAPI["UpdateInterfaceInput"];

export type UpdateInterfacesPageInput =
  InterfacesAPI["UpdateInterfacesPageInput"];

export type GetInterfaceOutput = InterfacesAPI["GetInterfaceOutput"];

export type Collaborator = InterfacesAPI["Collaborator"];

export type GetFeatureFlagsOutput = InterfacesAPI["GetFeatureFlagsOutput"];

export type ListTablesResponse = InterfacesAPI["ListTablesResponse"];
export type Table = ListTablesResponse[number];

export const clients: {
  chatbots: ReturnType<typeof createChatbotsFetchClient>;
  interfaces: ReturnType<typeof createInterfacesFetchClient>;
  monolith: ReturnType<typeof createMonolithFetchClient>;
  tables: ReturnType<typeof createTablesFetchClient>;
  zslapi: ReturnType<typeof createZslApiFetchClient>;
} = {
  chatbots: createChatbotsFetchClient({
    baseUrl: "/api/proxy/chatbots/",
    fetch: fetchWithProjectSession,
  }),
  interfaces: createInterfacesFetchClient({
    baseUrl: "/api/proxy/interfaces/",
    fetch: fetchWithProjectSession,
  }),
  monolith: createMonolithFetchClient({
    baseUrl: "/api/proxy/monolith/",
  }),
  tables: createTablesFetchClient({
    baseUrl: "/api/proxy/tables/api/v0/",
  }),
  zslapi: createZslApiFetchClient({
    baseUrl: "/api/proxy/zslapi/",
  }),
} as const;

export const zrpc = {
  chatbots: createClient(clients.chatbots),
  interfaces: createClient(clients.interfaces),
  monolith: createClient(clients.monolith),
  tables: createClient(clients.tables),
  zslapi: createClient(clients.zslapi),
} as const;
